import axios from 'axios';
import { apiUrl } from '../..';
import { format } from 'date-fns';

export const getConfigPPN = (data,token)=>(dispatch)=>{
    dispatch({
        type:'FETCH ACTION CONFIG'
    })
    axios.post(`${apiUrl.url}v1/suryaharapan/config/`,data,{
        headers:{
            'Authorization':`Bearer ${token}`,
            'content-type':'application/x-www-form-urlencoded'
        }
    })
    .then(res=>{
        const ResponseAPI = res.data;
        dispatch({
            type:'FETCH SUCCESSED CONFIG',
            payload:ResponseAPI.data[0].value
        })
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:'Disconnect from server'
            })
        }
    })
}

export const editConfig = (nama,data,token,setOpenSnackbar,onCalculateHarga)=>(dispatch)=>{
    dispatch({
        type:'FETCH ACTION CONFIG'
    })
    axios.put(`${apiUrl.url}v1/suryaharapan/config/${nama}`,data,{
        headers:{
            'Authorization':`Bearer ${token}`,
            'content-type':'application/x-www-form-urlencoded'
        }
    }).then(res=>{
        const ResponseAPI=res.data;
        dispatch({
            type:'SUCCEESED EDIT CONFIG',
            message:ResponseAPI.message,
            payload:ResponseAPI.NilaiPPN
        })
        onCalculateHarga();
        setOpenSnackbar(true);
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:'Disconnect from server'
            })
        }
    })
}
export const getIzinAkses = (data,setOpenToko,setLabelOpen)=>(dispatch)=>{
    dispatch({
        type:'FETCH ACTION CONFIG'
    })
    axios.post(`${apiUrl.url}v1/suryaharapan/config/`,data)
    .then(res=>{
        const ResponseAPI = res.data;
        dispatch({
           type:'SUCCEESED CHANGE STATUS AKSES',
            message:ResponseAPI.message,
            payload:{
                'status':ResponseAPI.data[0].status,
                'waktu':format(new Date(ResponseAPI.data[0].waktu),'yyyy-MM-dd HH:mm:ss')
            }
        })
        if(ResponseAPI.data[0].status==="Buka Akses"){
            setLabelOpen(ResponseAPI.data[0].status);
            setOpenToko(true);
        }else if(ResponseAPI.data[0].status==="Tutup Akses"){
            setOpenToko(false);
            setLabelOpen(ResponseAPI.data[0].status);
        }
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:'Disconnect from server'
            })
        }
    })
}
export const getLoginWithAkses = (data,loginAkses)=>(dispatch)=>{
    dispatch({
        type:'FETCH ACTION CONFIG'
    })
    axios.post(`${apiUrl.url}v1/suryaharapan/config/`,data)
    .then(res=>{
        const ResponseAPI = res.data;
        dispatch({
           type:'SUCCEESED CHANGE STATUS AKSES',
            message:ResponseAPI.message,
            payload:{
                'status':ResponseAPI.data[0].status,
                'waktu':format(new Date(ResponseAPI.data[0].waktu),'yyyy-MM-dd HH:mm:ss')
            }
        })
        loginAkses();
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:'Disconnect from server'
            })
        }
    })
}
export const editStatusAkses = (namaconfig,data,token)=>(dispatch)=>{
    dispatch({
        type:'FETCH ACTION CONFIG'
    })
    axios.patch(`${apiUrl.url}v1/suryaharapan/config/${namaconfig}`,data,{
        headers:{
            'Authorization':`Bearer ${token}`,
            'content-type':'application/x-www-form-urlencoded'
        }
    })
    .then(res=>{
        const ResponseAPI=res.data;
        dispatch({
            type:"CLEAR STATUS AKSES"
        })
        dispatch({
           type:'SUCCEESED CHANGE STATUS AKSES',
            message:ResponseAPI.message,
            payload:{
                'status':ResponseAPI.data[0].status,
                'waktu':format(new Date(ResponseAPI.data[0].waktu),'yyyy-MM-dd HH:mm:ss')
            }
        })
    })
    .catch(error=>{
        if(error.response){
            const ResponseError = error.response.data;
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:ResponseError.message
                })
        }else if(error.request){
            dispatch({
                    type:'FETCH FAILED CONFIG',
                    payload:'Disconnect from server'
            })
        }
    })

}